import React, { useEffect, useState } from "react";
import api from "../../../api/api";
import toast from "react-hot-toast";

const AdminContacts = () => {
  const [contacts, setContacts] = useState([]);

  const load = async () => {
    const res = await api.get("/contacts");
    setContacts(res.data);
  };

  const updateStatus = async (id, status) => {
    try {
      await api.put(`/contacts/${id}`, { status });
      toast.success("Contact updated");
      load();
    } catch (err) {
      toast.error(err.cleanMessage);
    }
  };

  const remove = async (id) => {
    if (!window.confirm("Delete contact message?")) return;

    try {
      await api.delete(`/contacts/${id}`);
      toast.success("Contact deleted");
      load();
    } catch (err) {
      toast.error(err.cleanMessage);
    }
  };

  useEffect(() => {
    load();
  }, []);

  return (
    <section>
      <h1 className="text-3xl font-black text-[#0b6b1d] mb-6">
        Contact Messages
      </h1>

      <div className="space-y-4">
        {contacts.map((item) => (
          <div key={item.id} className="bg-white rounded-3xl border p-6">
            <div className="flex justify-between gap-4">
              <div>
                <h3 className="font-black text-lg">{item.subject}</h3>
                <p className="text-sm text-slate-500">
                  {item.name} — {item.email}
                </p>
                {item.phone && (
                  <p className="text-sm text-slate-500">{item.phone}</p>
                )}
              </div>

              <span className="text-xs bg-slate-100 px-3 py-1 rounded-full h-fit">
                {item.status}
              </span>
            </div>

            <p className="mt-4 text-slate-700 leading-relaxed">
              {item.message}
            </p>

            <div className="flex flex-wrap gap-2 mt-5">
              {["new", "read", "replied", "archived"].map((s) => (
                <button
                  key={s}
                  onClick={() => updateStatus(item.id, s)}
                  className="px-4 py-2 rounded-xl bg-slate-100 hover:bg-[#0b6b1d] hover:text-white text-sm font-bold"
                >
                  {s}
                </button>
              ))}

              <button
                onClick={() => remove(item.id)}
                className="px-4 py-2 rounded-xl bg-red-50 text-red-600 text-sm font-bold"
              >
                Delete
              </button>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default AdminContacts;